import "@Styles/Main.less"

import DataWebPage from "@Scripts/Pages/DataWebPage";
import BasePage from "@Scripts/Pages/BasePage";
import CookieTermsPage from "@Scripts/Pages/CookieTermsPage";
import ProductListPage from "@Scripts/Pages/ProductListPage";
import OrderStatusPage from "@Scripts/Pages/OrderStatusPage";
import SearchListPage from "@Scripts/Pages/SearchListPage";
import CheckoutConfirmPage from "@Scripts/Pages/CheckoutConfirmPage";

let App: any = {
    instances: {},
    pages: {},
    routes: {}
};

App.pages.DataWebPage = DataWebPage;
App.pages.BasePage = BasePage;
App.pages.CookieTermsPage = CookieTermsPage;
App.pages.ProductListPage = ProductListPage;
App.pages.OrderStatusPage = OrderStatusPage;
App.pages.SearchListPage = SearchListPage;
App.pages.CheckoutConfirmPage = CheckoutConfirmPage;

(<any>window).App = App;